// extracted by mini-css-extract-plugin
export var navbar = "navbar-module--navbar--N9mmV";
export var scroll = "navbar-module--scroll--igGkl";
export var link = "navbar-module--link--dmzfs";